import type { FC, PropsWithChildren } from 'react';
import { DndProvider } from 'react-dnd';
// @ts-ignore consider migration to react-dnd-html5-backend
import HTML5Backend from 'react-dnd-mouse-backend';

const DndProviderComponent: FC<PropsWithChildren> = ({ children }) => {
  return <DndProvider backend={HTML5Backend}>{children}</DndProvider>;
};

export default DndProviderComponent;
